module.exports = __webpack_public_path__ + "static/img/1.44da360.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/sp/1.png
// module id = Qxyo
// module chunks = 0